import { getFormattedPeriod } from 'packages/common/utils/format';
import resource from '../resource';

export function get(id) {
  return resource.get(id).then(response => response.data);
}

export function generatePayment(params) {
  return resource.generatePayment(params);
}

export function create(company) {
  return resource.create(company);
}

export function getPayments(selectedDate, page) {
  const competence = getFormattedPeriod(selectedDate);
  return resource.getPayments(competence, page).then(response => response.data);
}

export function getPaymentById(id) {
  return resource.getPaymentById(id).then(response => response.data);
}

export function deletePayment(paymentId) {
  return resource.deletePayment(paymentId);
}

export function getRpa(params) {
  return resource.generateReport(params).then(response => response.data);
}
